export default __webpack_public_path__ + "static/media/selectTriangleDark.d90fcad6.svg";